/* Pure Patina: make the existing Safe As Milk Slick product gallery wrap continuously. */
(function () {
  function enableLoop() {
    if (typeof window.jQuery !== 'function') return;
    window.jQuery('.js-product-slider.slick-initialized').each(function () {
      var $slider = window.jQuery(this);
      if ($slider.slick('slickGetOption', 'infinite') !== true) {
        $slider.slick('slickSetOption', 'infinite', true, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(enableLoop, 0);
    }, { once: true });
  } else {
    window.setTimeout(enableLoop, 0);
  }
})();
